import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const CommonModal = (props) => {
  return (
    <Modal isOpen={props.isOpen} toggle={props.toggler} className={props.className} size={props.size} centered>
      <ModalHeader toggle={props.toggler} className='com_modal_header'>
        {props.title}
      </ModalHeader>
      <ModalBody className={props.bodyClass}>
        {props.children}
      </ModalBody>
      {/* <ModalFooter>
        <Btn attrBtn={{ color: 'secondary', onClick: props.toggler }} >{Close}</Btn>
        <Btn attrBtn={{ color: 'primary', onClick: props.toggler }}>{SaveChanges}</Btn>
      </ModalFooter> */}
    </Modal>
  );
};

export default CommonModal;